import * as React from 'react';

interface NativeSectionProps {
  paragraphs: string[];
}

export function NativeSection({ paragraphs }: NativeSectionProps) {
  return (
    <section className="whyus-native">
      <style>{`
        .whyus-native {
          padding: 72px 24px;
          background: #fff;
        }
        .whyus-native-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .whyus-native h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 24px;
          line-height: 1.3;
        }
        .whyus-native p {
          font-size: 17px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 20px;
        }
        .whyus-native p:last-child {
          margin-bottom: 0;
        }
        @media (max-width: 640px) {
          .whyus-native h2 {
            font-size: 24px;
          }
          .whyus-native p {
            font-size: 16px;
          }
        }
      `}</style>
      <div className="whyus-native-inner">
        <h2>Nuestro negocio ES la web.</h2>
        {paragraphs.map((paragraph) => (
          <p key={paragraph.slice(0, 40)}>{paragraph}</p>
        ))}
      </div>
    </section>
  );
}
